import request from "@assets/js/axios";
const { instance: $axios } = request;
class Pay {
  constructor() {}
  // 支付信息
  payInfo ({ order_sn, type = 'visa' }) {
    const params = {
      order_type: type,
      order_sn,
      payment_type: 'YspayAlipay'
    }
    return $axios.get('/Yspay/request', { params });
  }
}

export default new Pay();